import {
  W_TO_W_INVALID_REQUEST,
  W_TO_W_FAILED,
  W_TO_W_SUCCESS,
  W_TO_W_INVALID_WALLETID,
  W_TO_W_INVALID_AMOUNT,
  W_TO_W_INVALID_WALLETOWNERID,
  W_TO_W_INVALID_CUSTOMERID,
  W_TO_W_ACCOUNT_NOT_EXISTS,
  W_TO_W_INVALID_CURRENCY,
  W_TO_W_WALLETID_NOTFOUND,
  W_TO_W_INSUF_AMOUNT,
  W_TO_W_OPERATION_NOT_PERMITTED,
  LOADING_W_T_W,
  RESET_W_TO_W,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  error: false,
  invalidRequest: false,
  operationNotPermitted: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_W_T_W:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        error: false,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "",
      };

    case W_TO_W_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        error: false,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Transfer Failed",
      };
    case W_TO_W_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidRequest: true,
        operationNotPermitted: false,
        status: "Something went wrong...please try again",
      };

    case W_TO_W_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        error: false,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Transaction Successful"
      };

    case W_TO_W_INVALID_WALLETID:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Invalid Wallet Id, Please try again!",
      };

    case W_TO_W_INVALID_AMOUNT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Invalid Amount!",
      };

    case W_TO_W_INVALID_WALLETOWNERID:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Invalid Wallet Owner ID, Please try again!",
      };

    case W_TO_W_INVALID_CUSTOMERID:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Invalid Customer Id, Please try again!",
      };

    case W_TO_W_ACCOUNT_NOT_EXISTS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Account does not exist",
      };

    case W_TO_W_INVALID_CURRENCY:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Invalid Currency, Please try again!",
      };

    case W_TO_W_WALLETID_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Wallet Id Not Found, Please try again!",
      };

    case W_TO_W_INSUF_AMOUNT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Insufficient Amount!",
      };

    case W_TO_W_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        error: false,
        invalidRequest: false,
        operationNotPermitted: true,
        status: "Operation Not Permitted",
      };

    case RESET_W_TO_W:
      return (state = initialState);

    default:
      return state;
  }
};
